/**
 * Kit card include thumbs — pick which image shows on the cover.
 * Also used on collection PLP kit strips (data-kit-src).
 */
(function () {
  function imgKey(url) {
    if (!url) return "";
    var s = String(url).split("?")[0];
    var file = s.split("/").pop() || "";
    return file.replace(/_\d+x\d*/g, "").toLowerCase();
  }

  function setActiveInclude(list, activeBtn) {
    if (!list) return;
    list.querySelectorAll("[data-kit-pick]").forEach(function (btn) {
      var on = btn === activeBtn;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function pickKitMedia(btn) {
    var media = btn.closest(".selfabout-kit-media");
    if (media) {
      var framesEl = media.querySelector("[data-kit-frames]");
      if (!framesEl) return;
      var imgs = framesEl.querySelectorAll(".selfabout-kit-media__frame");
      var thumbImg = btn.querySelector("img");
      var thumbSrc =
        (thumbImg && (thumbImg.currentSrc || thumbImg.getAttribute("src"))) ||
        "";
      var hiSrc = btn.getAttribute("data-kit-src") || thumbSrc;
      var idx = Number(btn.getAttribute("data-kit-pick"));
      var path = "none";

      framesEl.classList.add("is-manual");

      var matched = null;
      if (thumbSrc && imgs.length) {
        var key = imgKey(thumbSrc);
        Array.prototype.forEach.call(imgs, function (img) {
          if (matched) return;
          if (imgKey(img.currentSrc || img.getAttribute("src")) === key) {
            matched = img;
          }
        });
      }

      if (matched) {
        path = "match-src";
        Array.prototype.forEach.call(imgs, function (img) {
          img.classList.toggle("is-active", img === matched);
        });
      } else if (imgs.length && hiSrc) {
        /* Thumbs can be kit-component images that are not in product.images —
           copy hi-res (or thumb) onto the active frame so the cover follows. */
        path = "paint-src";
        var target = imgs[0];
        Array.prototype.forEach.call(imgs, function (img, i) {
          img.classList.toggle("is-active", i === 0);
        });
        target.setAttribute("src", hiSrc);
        target.removeAttribute("srcset");
      } else if (Number.isFinite(idx) && idx >= 0 && idx < imgs.length) {
        path = "index";
        Array.prototype.forEach.call(imgs, function (img, i) {
          img.classList.toggle("is-active", i === idx);
        });
      } else {
        return;
      }

      setActiveInclude(
        media.querySelector(".selfabout-kit-media__includes"),
        btn,
      );
      return;
    }

    var card = btn.closest("[data-selfabout-card]");
    if (!card) return;
    var src = btn.getAttribute("data-kit-src");
    var primary = card.querySelector(".selfabout-collection__img--primary");
    if (!primary || !src) {
      return;
    }
    card.classList.add("is-kit-manual");
    primary.setAttribute("src", src);
    primary.removeAttribute("srcset");
    primary.style.setProperty("opacity", "1");
    var alt = card.querySelector(".selfabout-collection__img--alt");
    if (alt) {
      alt.style.setProperty("opacity", "0");
    }
    setActiveInclude(card.querySelector(".selfabout-collection__kit-includes"), btn);
  }

  document.addEventListener(
    "click",
    function (event) {
      var btn = event.target.closest("[data-kit-pick]");
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      pickKitMedia(btn);
    },
    true,
  );

  document.addEventListener(
    "pointerover",
    function (event) {
      if (event.pointerType === "touch") return;
      var frames = event.target.closest && event.target.closest("[data-kit-frames]");
      if (!frames || frames.classList.contains("is-manual")) return;
      if (!frames.querySelector(".selfabout-kit-media__frame:nth-child(2)")) return;
      frames.classList.add("is-cover-hover");
    },
    true,
  );
  document.addEventListener(
    "pointerout",
    function (event) {
      var frames = event.target.closest && event.target.closest("[data-kit-frames]");
      if (!frames) return;
      var to = event.relatedTarget;
      if (to && frames.contains(to)) return;
      frames.classList.remove("is-cover-hover");
    },
    true,
  );
})();
